module Meevo {
    export class Guid {
        protected guid: string = "00000000000000000000000000000000";

        constructor(guidStr: string) {
            if (guidStr == null || !guidStr) {
                return;
            }
            guidStr = guidStr.replace(/[{}()\-]/g, "");
            let regex = /^[0-9a-fA-F]{32}/i;
            let matchArray = guidStr.match(regex);
            if (!matchArray && guidStr.length === 32) {
                throw new TypeError("the string passed in is not a valid Guid.");
            }
            this.guid = guidStr;
        }

        toString(format?: string): string {
            if (format === null || format == undefined) {
                format = "D";
            }
            format = format.toUpperCase();
            if (!format.match(/^[NDBP]/)) {
                throw new TypeError("the string passed in is not a valid format.");
            }
            let result: string = "";
            switch (format) {
                case "B":
                    result += "{";
                    break;
                case "P":
                    result += "(";
                    break;

                default:
            }
            for (let i = 0; i < 32; i++) {
                if (i === 8 || i === 12 || i === 16 || i === 20) {
                    result = result + "-";
                }
                result += String.fromCharCode(this.guid.charCodeAt(i));
                if (format === "N") {
                    continue;
                }
            }
            switch (format) {
                case "B":
                    result += "}";
                    break;
                case "P":
                    result += ")";
                    break;

                default:
            }
            return result;
        }

        static empty: Guid = new Guid("00000000-0000-0000-0000-000000000000");

        static toString(guid: Guid, format?: string) {
            try {
                return new Guid(guid.toString()).toString(format);
            } catch (e) {
                return guid == null ? guid : guid.toString();
            }
        }

        static newGuid(): Guid {
            let result: string;
            let char: string;

            result = "";
            for (let i = 0; i < 32; i++) {
                char = Math.floor(Math.random() * 16).toString(16).toUpperCase();
                result = result + char;
            }
            return new Guid(result);
        }

        static newSqlSequentialGuid(): Guid {
            let baseUtc = 2208988800000; // Total number of millisenconds between 1900-1-1 and 1970-1-1
            let now = new Date();
            let nowUtc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
            let days = Math.floor((nowUtc + baseUtc) / 1000 / 60 / 60 / 24);
            let msecs = Math.floor((now.getUTCHours() * 60 * 60 * 1000) +
                (now.getUTCMinutes() * 60 * 1000) +
                (now.getUTCSeconds() * 1000) +
                (now.getUTCMilliseconds()));
            // we reverse the byte arrays to match SQL Server ordering.
            let daysArray = days.getByteArray().reverse();
            // Note that SQL Server is accurate to 1/300th of a millisecond so we divide by 3.33333333 
            let msecsArray = Math.floor(msecs / 3.33333333).getByteArray(8).reverse();

            let result = "";
            for (let i = 0; i < 20; i++) {
                result = result + Math.floor(Math.random() * 16).toString(16);
            }
            result += daysArray[daysArray.length - 2].toString(16).padLeft(2, "0");
            result += daysArray[daysArray.length - 1].toString(16).padLeft(2, "0");
            result += msecsArray[msecsArray.length - 4].toString(16).padLeft(2, "0");
            result += msecsArray[msecsArray.length - 3].toString(16).padLeft(2, "0");
            result += msecsArray[msecsArray.length - 2].toString(16).padLeft(2, "0");
            result += msecsArray[msecsArray.length - 1].toString(16).padLeft(2, "0");
            return new Guid(result);
        }

        private static getByteArray(value: number, arrayLenght = 4): number[] {
            let result: number[] = [];
            while (value > 0) {
                let byte = value & 0xff;
                result.push(byte);
                value = (value - byte) / 256;
                if (result.length === arrayLenght) {
                    return result;
                }
            }
            for (let i = result.length; i <= arrayLenght; i++) {
                result.push(0);
            }
            return result;
        }

        static equals(guid1: Guid, guid2: Guid): boolean {
            try {
                return new Guid(guid1.toString()).toString("N") === new Guid(guid2.toString()).toString("N");
            } catch (e) {
                return false;
            }
        }

        equals(guid: Guid): boolean {
            try {
                return this.toString("N") === new Guid(guid.toString()).toString("N");
            } catch (e) {
                return false;
            }
        }

        valueOf(): string {
            return this.toString("N");
        }
    }

    // 7/30/2015 Alex & David.
    // we had tyo create this prototype function in the String 
    // cause when the Guids get returned from the server
    // they get returned as strings, so there is a possibility 
    // when comparing what we think is a guid in reallity is a string.
    // this function will resolve that prb.
    String.prototype.equals = function(str: any): boolean {
        try {
            return Guid.equals(new Guid(this), new Guid(str.toString()));
        }
        catch (e) {
            return this === str;
        }
    }
    String.prototype.padLeft = function (lenght: number, paddingChar = " "): string {
        let padding = "";
        try {
            paddingChar = paddingChar.substr(0, 1);
        }
        catch (e) {
            paddingChar = " ";
        }
        for (let i = this.length; i < lenght; i++) {
            padding = padding + paddingChar;
        }
        return padding + this;
    }
    String.prototype.padRight = function (lenght: number, paddingChar = " "): string {
        let padding = "";
        try {
            paddingChar = paddingChar.substr(0, 1);
        }
        catch (e) {
            paddingChar = " ";
        }
        for (let i = this.length; i < lenght; i++) {
            padding = padding + paddingChar;
        }
        return this + padding;
    }

    Number.prototype.getByteArray = function (arrayLenght = 4): number[] {
        let result: number[] = [];
        let value = this;
        while (value > 0) {
            let byte = value & 0xff;
            result.push(byte);
            value = (value - byte) / 256;
            if (result.length === arrayLenght) {
                return result;
            }
        }
        for (let i = result.length; i <= arrayLenght; i++) {
            result.push(0);
        }
        return result;
    }
}

interface String {
    equals(str: any): boolean;
    padLeft(lenght: number, paddingChar: string): string;
    padRight(lenght: number, paddingChar: string): string;
}
interface Number {
    getByteArray(arrayLenght?: number): number[];
}